import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LineClampDirective } from './line-clamp.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [LineClampDirective],
  exports: [LineClampDirective],
})
export class LineClampModule {}
